<script setup lang="ts">
import { Head } from "@inertiajs/vue3"
import { SbList } from "@unio/saltbox-ui"
import { ref } from "vue"

import EmptyState from "@/components/EmptyState.vue"
import IndexHeader from "@/components/IndexHeader.vue"
import ItemTypeFormSlideover from "@/components/ItemTypeFormSlideover.vue"
import ItemTypeListItem from "@/components/ItemTypeListItem.vue"
import NarrowPage from "@/components/NarrowPage.vue"
import SearchInput from "@/components/SearchInput.vue"
import { useNavbar } from "@/composables/useNavbar"
import { useSearchableIndex } from "@/composables/useSearchableIndex"
import { ICON } from "@/lib/icons"
import { itemTypesPath } from "@/routes"
import type { ItemTypeSummary } from "@/types/models"

const { title } = useNavbar({ title: "Item Types" })

interface Props {
  item_types: ItemTypeSummary[]
  query: string
  colors: string[]
  icons: string[]
}

const props = defineProps<Props>()

const { search } = useSearchableIndex(props.query, itemTypesPath)
const slideoverOpen = ref(false)
</script>

<template>
  <Head :title="title" />

  <NarrowPage>
    <IndexHeader
      :count="item_types.length"
      noun="type"
      button-label="New Type"
      @action="slideoverOpen = true"
    />

    <SearchInput v-model="search" placeholder="Search item types..." />

    <SbList v-if="item_types.length" bordered separator>
      <ItemTypeListItem v-for="itemType in item_types" :key="itemType.id" :item-type="itemType" />
    </SbList>

    <EmptyState v-else :icon="ICON.itemType" noun="item types" :query="query" />
  </NarrowPage>

  <ItemTypeFormSlideover
    v-model:open="slideoverOpen"
    :colors="colors"
    :icons="icons"
    :item-type="null"
  />
</template>
